/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import {
  getGenericDataValues,
  getSLDByAssetpointId,
  getSldDIValuesByAstpt,
  getSldDataValuesByAstpt,
} from '../../Service/sldService';
import {
  replaceDataValuesInSLD,
  replaceSLDFileWithNewValues,
} from '../../utils/sldUtils';
import { SLDViewer } from '@orxagridrepo/sld-ui';
import { session } from '../../Service/APIService';
import { withRouter } from 'react-router-dom';
import MenuItems from './MenuItems/MenuItems';
import { getSLDDIIntervalTime, getSLDAIIntervalTime } from '../../utils/helper';
import ZoomWrapper from './ZoomContainer/ZoomWrapper';

const menuId = 'cbBox';

const SLDViewerContainer = (props) => {
  const { SubstationId } = props;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [sldFileObject, setSLDFileObject] = useState([]);
  const [isEmpty, setEmpty] = useState(false);

  const [showOperationModal, setShowOperationModal] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);

  const sldRef = useRef([]);
  const substationRef = useRef(SubstationId);

  useEffect(() => {
    sldRef.current = sldFileObject;
  }, [sldFileObject]);

  useEffect(() => {
    substationRef.current = SubstationId;
  }, [SubstationId]);

  const fetchSLDFile = async () => {
    try {
      setLoading(true);
      setEmpty(false);

      setSLDFileObject([]);
      sldRef.current = [];

      const parsedSldObject = await getSLDByAssetpointId(SubstationId);
      setSLDFileObject(parsedSldObject);
      if (parsedSldObject.length) {
        await Promise.all([
          refreshDI(parsedSldObject),
          refreshAI(parsedSldObject),
        ]);
      } else {
        setEmpty(true);
      }

      setLoading(false);
    } catch (err) {
      setError(true);
      setLoading(false);
    }
  };

  //DI ONLY
  const refreshDI = async (sldObject) => {
    if (!sldObject?.length) return;
    
    try {
      const diValues = await getSldDIValuesByAstpt(substationRef.current);
      const updatedSLD = await replaceSLDFileWithNewValues(
        sldObject,
        diValues
      );
      sldRef.current = updatedSLD;
      setSLDFileObject(updatedSLD);
    } catch (err) {
      console.error('DI refresh failed', err);
    }
  };

  //AI ONLY
  const refreshAI = async (sldObject) => {
    if (!sldObject?.length) return;

    try {
      const userInfo = session.user();
      const [dataValues, genericValues] = await Promise.all([
        getSldDataValuesByAstpt(substationRef.current),
        userInfo?.showGDSData
          ? getGenericDataValues(substationRef.current)
          : Promise.resolve(null),
      ]);

      const updatedSLD = await replaceDataValuesInSLD(
        sldObject,
        dataValues.apiResultPDSData,
        dataValues.apiResultADSData,
        dataValues?.apiResultDCData,
        genericValues
      );

      sldRef.current = updatedSLD;
      setSLDFileObject(updatedSLD);
    } catch (err) {
      console.error('AI refresh failed', err);
    }
  };

  useEffect(() => {
    if (SubstationId) {
      fetchSLDFile();
    }
  }, [SubstationId]);

  //DI INTERVAL 
  useEffect(() => {
    if (!SubstationId) return;
    const interval = setInterval(() => {
      if (sldRef.current?.length) {
        refreshDI(sldRef.current);
      }
    }, getSLDDIIntervalTime() * 1000);

    return () => clearInterval(interval);
  }, [SubstationId]);

  //AI INTERVAL 
  useEffect(() => {
    if (!SubstationId) return;
    const interval = setInterval(() => {
      if (sldRef.current?.length) {
        refreshAI(sldRef.current);
      }
    }, getSLDAIIntervalTime() * 1000);

    return () => clearInterval(interval);
  }, [SubstationId]);

  const onRightClick = (e, asset) => {
    e.preventDefault();
    setShowOperationModal(true);
    setSelectedAsset(asset);
  };


 if (loading) {
    return <span>Loading...</span>;
  }
  if (error) {
    return <span>Please check SLD response</span>;
  }
  if (isEmpty) {
    return <span>No Data is returned for specified SLD</span>;
  }

  return (
    <>
      <MenuItems
        menuId={menuId}
        fetchSLDValues={() => {
          refreshDI(sldRef.current);
          refreshAI(sldRef.current);
        }}
        showOperationModal={showOperationModal}
        selectedAsset={selectedAsset}
        hideOperationModal={() => {
          setShowOperationModal(false);
          setSelectedAsset(null);
        }}
      />
      <ZoomWrapper>
        <SLDViewer
          data={sldFileObject}
          onRightClick={onRightClick}
          isNoParamsSelectedTitleShow={false}
        />
      </ZoomWrapper>
    </>
  );
};

export default withRouter(SLDViewerContainer);
